import * as React from "react";
import {RouteComponentProps} from "react-router";
import {connect, Dispatch} from "react-redux";
import {withRouter} from "react-router-dom";
import Job from "../../../model/job/Job";
import Loading from "../../ui/loading/Loading";
import Routes from "../../../navigation/route/Route";
import {OnFailure, OnSuccess, OnSuccessData} from "../../../store/action/actionHelpers";
import {fetchJob} from "../../../store/action/job/job";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";

interface RouteProps {
	/**
	 * Job identifier.
	 */
	jobId: string
}

interface DispatchProps {
	fetchJob: (jobId: string, onSuccess: OnSuccessData<Job>, onFailure: OnFailure) => void
}

type ComponentProps = RouteComponentProps<RouteProps>;

type Props = ComponentProps & DispatchProps

class JobUuidRouteComponent extends React.Component<Props, {}> {

	componentDidMount() {
		this.props.fetchJob(this.props.match.params.jobId, (job) => this.navigateToJobDetails(job.referenceNumber), (err) => {
			notifyBugsnagAndShowToast(err, "Fetch job");
			this.navigateToJobsList()
		})
	}


	render() {
		return (
			<div className={"l-page boxed"}>
				<Loading isLoading={true}/>
			</div>
		)
	}

	/**
	 * Navigate to job list
	 */
	private navigateToJobsList() {
		this.props.history.push(Routes.JobsList);
	}

	/**
	 * Navigate to job details
	 */
	private navigateToJobDetails(jobRefNumber: string) {
		this.props.history.push(Routes.EditJob(jobRefNumber));
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchJob: (jobId: string, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			fetchJob(jobId, onSuccess, onFailure))
	}
}

export default withRouter(connect(null, mapDispatchToProps)(JobUuidRouteComponent));